// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1vem2","label":"Completed_label__2fEvf"};